import {Form, Input, Modal} from 'antd'
import {useEffect, useState} from 'react'
import './style.css'
import {Scrollbars} from "react-custom-scrollbars-2"
import {reConstructionCategoryActions} from './store/actions'
import CustomButton from "../../../components/CustomButton"
import {useDispatch, useSelector} from 'react-redux'
import {useDebounce} from "use-debounce"

const UpdateReConstructionCategoryModal = ({update, visible, setVisible, currentCategory, setCurrentCategory}) => {
    const [searchCategory, setSearchCategory] = useState(null)
    const [category] = useDebounce(searchCategory, 500)
    const {changed, isSending, list} = useSelector(state => state.reConstructionCategoryReducer)
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const pageSize = 10

    useEffect(() => {
        return () => {
            dispatch(reConstructionCategoryActions.clear())
        }
    }, [])

    useEffect(() => {
        if (category?.length > 1) {
            getCategories({
                name: category,
                pageSize: pageSize
            })
        }
    }, [category])

    useEffect(() => {
        if (changed)
            handleCancel()
    }, [changed])

    useEffect(() => {
        if (currentCategory) {
            form.setFieldsValue({
                codeKKM: currentCategory.codeKKM,
                name: currentCategory.name,
                reConstructionCategory: currentCategory.parent ? `${currentCategory.parent.codeKKM} ${currentCategory.parent.name}` : null
            })
        }
    }, [currentCategory])

    const getCategories = (values) => {
        dispatch(reConstructionCategoryActions.getList(values))
    }

    const handleCancel = () => {
        setVisible(false)
        form.resetFields()
        setCurrentCategory(null)
    }

    const add = (values) => {
        update({
            id: currentCategory.id,
            name: values.name.trim()
        })
    }

    return (
        <Modal
            footer={[
                <CustomButton
                    key="submit"
                    loading={isSending}
                    type="green"
                    onClick={() => form.validateFields().then(values => add(values))}
                >
                    Сохранить
                </CustomButton>
            ]}
            title="Редактирование категории"
            open={visible}
            width="1050px"
            onCancel={handleCancel}
        >
            <Scrollbars
                autoHeight
                autoHide
                autoHeightMax={600}
                height={600}
            >
                <Form
                    form={form}
                    labelCol={{span: 7}}
                    name="Category"
                >
                    <Form.Item
                        label="Название категории"
                        name="name"
                        rules={[
                            {
                                required: true,
                                whitespace: true
                            }
                        ]}
                    >
                        <Input.TextArea
                            autoSize={{minRows: 1, maxRows: 3}}
                            placeholder="Введите название категории"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Код категории по каталогу-классификатору"
                        name="codeKKM"
                    >
                        <Input.TextArea
                            readOnly
                            autoSize={{
                                minRows: 1,
                                maxRows: 3
                            }}
                            placeholder="Введите код категории по каталогу-классификатору"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Родительская категория"
                        name="reConstructionCategory"
                    >
                        <Input.TextArea
                            readOnly
                            autoSize={{minRows: 1, maxRows: 3}}
                        />
                    </Form.Item>
                </Form>
            </Scrollbars>
        </Modal>
    )
}

export default UpdateReConstructionCategoryModal